import View             from '@widesk-ui/components/View';
import React            from 'react';
import useDesignTokens  from '@/hooks/useDesignTokens';

export const FieldLabelSlotContext = React.createContext<HTMLElement | null>(null);

export default function Field(props: { label: React.ReactNode; children: React.ReactNode; help?: React.ReactNode; }) {
	const tokens = useDesignTokens();
	const [slot, setSlot] = React.useState<HTMLDivElement | null>(null);

	return (
		<View gap={4}>
			<View row spread centerV gap={4}>
				<View row wrap gap={4} size={13} style={{ fontWeight: 600 }}>{props.label}</View>
				<div ref={setSlot} style={{ display: 'flex', flexShrink: 0 }} />
			</View>
			<FieldLabelSlotContext.Provider value={slot}>
				<View>
					{props.children}
				</View>
			</FieldLabelSlotContext.Provider>
			{!!props.help && (
				<View color={tokens.text.muted} size={12} lineHeight={1.45}>
					{props.help}
				</View>
			)}
		</View>
	);
}

export function FieldLabelSuffix({ children }: { children: React.ReactNode; }) {
	const tokens = useDesignTokens();

	return (
		<View color={tokens.text.muted} style={{ fontWeight: 400 }}>
			{children}
		</View>
	);
}
